import { IRegistration } from "../registration";

export interface IQaRegistrationCreateRegistrationResponse {
    data: {
        success: boolean,
        results: IRegistration
    }
}